import React from 'react';
import { Data } from '../../types';
import { useAuthHelper } from '../../components/AuthContextProvider';
import { Site } from '../../api/types';
import { useData, dataFromDataset } from './DataProviderCache';
import * as SiteManager from '../domain/site-manager';

type ContextState =Data<Site[]> 
const Context = React.createContext<ContextState | null>(null);
function useSiteListData(): ContextState {
    const contextState = React.useContext(Context);
    if (contextState === null) {
        throw new Error('useSiteListData must be used within a SiteListProvider');
    }
    return contextState;
}

const SiteListProvider: React.FC<{ locationId: string }> = (props) => {
    const authHelper = useAuthHelper();
   
        const { dataset } = useData({
            cacheKey: 'site-list-data',
            id: props.locationId,
            dataFn: React.useCallback(() => SiteManager.getSites(authHelper,
                { locationId: props.locationId }), [
                authHelper,
                props.locationId
            ]),
        });

        const siteListData = dataFromDataset(dataset);
    

    return <Context.Provider value={siteListData}>{props.children}</Context.Provider>;
};

export { SiteListProvider, useSiteListData };
